function alphabetSelected(currentTarget) {
  var alphabetLIst = currentTarget.closest("[data-alphabets]");
  var allElements = alphabetLIst.querySelectorAll("a");
  allElements.forEach((element) => {
    if (element.classList.contains("active")) {
      element.classList.remove("active");
    }
  });
  currentTarget.classList.add("active");
  var id = currentTarget.getAttribute("data-id");
  document.querySelectorAll("[ingredient-title] h4").forEach((element) => {
    if (element.classList.contains("active")) {
      element.classList.remove("active");
    }
  });
  if (document.querySelector(`[data-ingredient-${id}]`) != null) {
    document
      .querySelector(`[data-ingredient-${id}] h4`)
      .classList.add("active");
  }
}

function updateSwatchDesc() {
  var colorDesc = $(
    ".product-form__input input:checked+label.color-swatch"
  ).attr("data-variant-shade-description");
  if (colorDesc != "") {
    $(".variant-desc").html(colorDesc);
  }
}
function colorSwatch() {
  updateSwatchDesc();
  $(".product-card-wrapper").on("mouseover touchstart",function () {
    var noscript = $(this).find("noscript");
    if(noscript){
      $($(noscript).html()).insertBefore(noscript);
      $(noscript).remove();
    }
  });
  $(".product-form__input .color-swatch").click(function () {
    $(".variant-selected-option").text(": " + $(this).attr("data-option"));
  });
  $(".product-form__input input").change(function () {
    updateSwatchDesc();
  });
}
function swatchChange(checkInput) {
  var wrapper = $(checkInput).closest(".card-wrapper");
  var img = $(checkInput).attr("data-variant-img");
  $(wrapper).find(".media>img:nth-child(1)").attr("src", img);
  $(wrapper)
    .find(".quick-add input[name=id]")
    .val($(checkInput).attr("data-variant-id"));
  $(wrapper).find(".cart-price").text($(checkInput).attr("data-variant-price"));
  $(wrapper).find(".media>img:nth-child(1)").removeAttr("srcset");
  $(wrapper).find(".sw-name-wrapper span").text($(checkInput).val());
}

function loadImages(images, index) {
  if (index < images.length) {
    let img = new Image();
    img.src = images[index];
    images[index] = img;
    images[index].onload = function () {
      loadImages(images, ++index);
    };
  }
}

function megaMenuHovering() {
  $(".mega-menu-wrapper .leading-none>a").on("mouseenter", function () {
    var img = $(this).closest(".mega-menu-wrapper").find("img");
    $(img).removeAttr("srcset");
    $(this)
      .closest(".mega-menu-wrapper")
      .find("img")
      .attr("src", $(this).attr("data-img"));
  });
  $(".header__inline-menu>ul>li").on("mouseenter", function () {
    if ($(this).attr("images-loaded") != 'true') {
      var images = [];
      $(this)
        .find(".mega-menu-wrapper .leading-none>a")
        .each(function (i, item) {
          images.push($(item).attr("data-img"));
        });
      loadImages(images,0)
      $(this).attr("images-loaded", true);
    }
  });
}
function openPopupModal(open) {
  if (open) {
    $("#PopupModal-video .modal").addClass("open");
  } else {
    $("#PopupModal-video .modal").removeClass("open");
  }
}

function debounce(func) {
  var wait =
    arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

  var timeout = void 0;
  return function () {
    var _this = this;

    for (
      var _len = arguments.length, args = Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(_this, args);
    }, wait);
  };
}
window.onresize = function (event) {
  debounce(productMediaChange(), 500);
};
function productMediaChange() {
  if (window.innerWidth < 749) {
    $(".product__media-wrapper").insertBefore(
      "variant-radios"
    );
  } else {
    $(".product__media-wrapper").insertBefore(".product__info-wrapper");
  }
}
$(document).ready(function () {
  //price move up
  colorSwatch();
  productMediaChange();
  megaMenuHovering();
  //
  $(".footer-block__heading").click(function () {
    $(this).toggleClass("ic-active");
  });
  var swiper = new Swiper(".testimonial-list", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    effect: "fade",
  });
});
/**
 * Accordion HTML
 */
class customAccordion extends HTMLElement {
  constructor() {
    super();

    this.accordionType = this.dataset.accordiontype;
    this.toggleBtns = this.querySelectorAll(".accordion__Toggle");

    this.toggleBtns.forEach((button) =>
      button.addEventListener("click", this.toggleAccordionBlock.bind(this))
    );
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event) {}

  /**
   * Escape Key Press to close drawer when focus is within the container
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
  }

  /**
   * Toggle Tabs on link click
   *
   * @param {event} Event instance
   */
  toggleAccordionBlock(event) {
    event.preventDefault();
    const toggleBtn = event.currentTarget;
    const targetContainer = toggleBtn.parentNode;
    const isOpen = targetContainer.classList.contains("open");
    isOpen
      ? this.closeAccordionBlock(toggleBtn)
      : this.openAccordionBlock(toggleBtn);
  }

  /**
   * Open Tab Container
   *
   * @param {Node} toggleBtn Accordion Block Open link
   */
  openAccordionBlock(toggleBtn) {
    let targetContainer = toggleBtn.parentNode;
    toggleBtn.setAttribute("aria-expanded", true);

    Utility.toggleElement(targetContainer, "open");
    if (this.accordionType == "single") {
      let siblingBlocks = targetContainer.parentNode.querySelectorAll(
        ".accordion__container"
      );
      siblingBlocks.forEach((element) => {
        if (element == targetContainer) {
          return;
        }
        element.classList.remove("open");
        element.querySelector(".accordion__block").classList.remove("open");
        element
          .querySelector(".accordion__toggle")
          .setAttribute("aria-expanded", false);
      });
    }
    Utility.trapFocus(targetContainer);
  }

  /**
   * Close Tab Container
   *
   * @param {Node} currentTab Tab Container link
   * @param {Node} tabContainer Tab Container to close
   */
  closeAccordionBlock(toggleFilterBtn) {
    const targetContainer = toggleFilterBtn.parentNode;
    toggleFilterBtn.setAttribute("aria-expanded", false);
    Utility.toggleElement(targetContainer, "close");
    Utility.removeTrapFocus(targetContainer);
  }
}
customElements.define("custom-accordion", customAccordion);
